import React from 'react';
import { C } from '../constants/theme';

export function LoadingSpinner({ text = 'Loading…' }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: 64, gap: 12 }}>
      <div style={{
        width: 36, height: 36, border: `3px solid ${C.primaryLight}`,
        borderTopColor: C.primary, borderRadius: '50%',
        animation: 'spin 0.7s linear infinite',
      }} />
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      <span style={{ fontSize: 13, color: C.textMuted }}>{text}</span>
    </div>
  );
}
